import { TReduxActions } from '../../../types/redux';
import { EGeneralRatingActionTypes } from '../../../actions/newReview';
import { TGeneralRating } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';

export const defaultValue = {
  value: 0,
};

export function generalRatingReducer(
  state: TGeneralRating = defaultValue,
  { type, payload }: TReduxActions,
): TGeneralRating {
  if (type === EGeneralRatingActionTypes.SetRating) {
    return {
      value: payload,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
